import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import { ErrorMessage, Field, Form, Formik } from "formik";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { useState } from "react";
import { toastMessage } from "../../../../helpers/toastMessage";
import mobioApi from "../../../../services";

const RejectModal = ({ modalOpen, setModalOpen, token, onboardingData }) => {
  console.log("onboardingData", onboardingData);
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const api = mobioApi(token);
      if (!onboardingData?.id && !values?.reason) {
        toastMessage("error", "Id or Reason is missing");
      }
      const response = await api.reject(onboardingData?.id, {
        reason: values.reason,
      });
      toastMessage("success", response?.data?.msg);
      onboardingData.verify = "Rejected";

      setModalOpen(false);
    } catch (error) {
      toastMessage("error", error?.response?.data.msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={"OnBoarding Rejections"}
      className={"country-city-modal header-modal-section"}
    >
      <div>
        <Formik
          initialValues={{
            cityDetail: "",
          }}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <div className="input-field-md-lg mb-20">
                <p className="m-0 font-14 font-500 mb-10">Rejection Reason</p>
                <Field
                  type="text"
                  name="reason"
                  placeholder="Enter Rejection Reason"
                />
                <ErrorMessage
                  name="reason"
                  component="div"
                  className="field-error"
                />
              </div>

              <div></div>
              {/*  */}

              <div className="mt-20">
                <MOButtonV2
                  text={"SUBMIT"}
                  type="submit"
                  textColor="#ffffff"
                  radius={4}
                  backgroundColor="#29AEE6"
                  height={44}
                  fontSize={11}
                  widthSize={"100%"}
                  padding={"16px 0px"}
                  disabled={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </MOModalWrapper>
  );
};

export default RejectModal;
